
// 模块类型
export const moduleTypes = [
    { label: "主页模块", value: 1 },
    { label: "暗网模块", value: 2 },
    { label: "发现模块", value: 3 },
    { label: "社区模块", value: 4 },
    { label: "图集模块", value: 5 },
    { label: "黄游模块", value: 6 },
    { label: "小说模块", value: 7 },
]

// 专题类型（进入专题的类型）
export const topicTypes = [
    { label: "短视频", value: 0 },
    { label: "长视频", value: 1 },
    { label: "黄游帖子", value: 2 },
    { label: "漫画", value: 3 },
    { label: "动漫", value: 4 },
    { label: "文字小说", value: 5 },
    { label: "有声小说", value: 6 },
    { label: "图组", value: 7 },
    { label: "社区帖子", value: 8 },
]

export const moduleShowTypes = [
    { label: "列表样式", value: 0 },
    { label: "多专题组合样式", value: 1 },
    { label: "多专题滑动列表样式", value: 2 },
    { label: "多专题滑动更多列表样式", value: 3 },
    { label: "多专题列表样式", value: 4 },
    { label: "社区样式", value: 5 },
    { label: "图集列表样式", value: 6 },
    { label: "黄游列表样式", value: 7 },
    { label: "小说列表样式", value: 8 },
    { label: "关注列表样式", value: 9 },
]

export function getTypeLabel(val, types) {
    const type = types.find(v => v.value == val)
    if (type) {
        return type.label
    }
    return ''
}

const newsTypeMapper = {
    SP: '短视频帖子',
    MOVIE: '长视频帖子',
    COVER: '图片帖子',
    SEED_LINK: '种子贴子',
    AD_SP: '视频广告',
    YELLOW_GAME: '黄游帖子',
    AD: '图片广告'
}

export function getNewsTypeName(key) {
    return newsTypeMapper[key || 'AD'] || newsTypeMapper.AD
}

const tagStyles = 'success/warning/danger/success'.split('/')
const tagStylesCount = tagStyles.length
export function getTagStyle(val) {
    return tagStyles[val % tagStylesCount]
}

/// 跑马灯类型
export const marqueeTypes = [
    {
        label: "首页模块",
        value: 1,
    },
    {
        label: "暗网模块",
        value: 2,
    },
    {
        label: "社区模块",
        value: 3,
    },
]

export function getMarqueeTypeName(val) {
    return getTypeLabel(val, marqueeTypes)
}

/// 视频权限
export const videoPermissionTypes = [
    { label: 'VIP会员', value: 0 },
    { label: '金币购买', value: 1 },
    { label: '免费', value: 2 },
]

/**
 * 奖品类型
 */
export const priceTypes = [
    // { label: "活跃值", value: 1 },
    { label: "金币", value: 2 },
    { label: "金币视频观影券", value: 3 },
    { label: "ai脱衣免费次数", value: 4 },
    { label: "会员卡", value: 5 },
    { label: "会员折扣券", value: 6 },
    { label: "实物", value: 7 },
    { label: "积分", value: 8 },
]

/**
 * 排序类型0-正序 1-倒序
 */
export const sortTypes = [
    { label: "正序", value: 0 },
    { label: "倒序", value: 1 },
]

export const passTypes = [
    { label: '上架', value: 1 },
    { label: '下架', value: 2 }
]

/**
 * 列表最大总数
 */
export const maxTotalTypes = [1000, 2000, 5000, 10000].map(v => ({ label: v.toString(), value: v }))

/**
 * 资源管理 - 预售卡配置 域名类型
 */
export const domainTypes = [
    { label: '背景图', value: 1 },
    { label: '浮窗', value: 2 },
    { label: '预售弹窗', value: 3 },
    // { label: 'Banner图', value: 4 },
    { label: '个人中心banner', value: 5 },
    { label: '支付按钮', value: 6 },
    { label: '金币视频区背景', value: 7 },
]
/**
 * 资源管理 - 预售卡配置 状态类型
 */
export const domainStatusTypes = [
    { label: '预定', value: 1 },
    { label: '尾款', value: 2 },
    { label: '未到尾款支付', value: 3 },
]

export const domainInnerLinks = [
    { label: '会员中心', value: 'yinseinner://vip_page' },
    { label: '金币商城', value: 'yinseinner://wallet_page' },
    { label: '活动详情页', value: 'yinseinner://Activity_page' },
    { label: '预售卡详情页', value: 'yinseinner://advancePage' },
]

/**
 * 链接类型
 */
export const linkTypes = [
    { label: '内链', value: 1 },
    { label: '外链', value: 2 },
]


export const productTypes = [
    { label: "会员卡", value: 0 },
    { label: "约会卡", value: 3 },
    { label: "新手卡", value: 5 },
    { label: "实体商品", value: 6 },
    { label: "楼凤优惠卡", value: 9 },
    { label: "楼凤全免卡", value: 10 },
    { label: "裸聊服务", value: 12 },
    { label: "视频折扣卡", value: 13 },
    { label: "视频免费卡", value: 14 },
    { label: "其它卡", value: 20 },
    { label: "预售卡", value: 21 },
]